import React, { AllHTMLAttributes } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
//import store from "store";
import styles from "./index.module.scss";
import NoDataLightSvg from "@/assets/icon-svg/account/nodata_ico-light.svg";
import NoDataSvg from "@/assets/icon-svg/account/nodata_ico.svg";
import XtSvg from "@/components/Xt/Svg";
interface NoDataProps extends AllHTMLAttributes<HTMLElement> {
  attr?: any;
  nodata?: React.ReactNode;
}
const { useTranslation } = Hooks;
const NoData: React.FC<NoDataProps> = ({ className, nodata }) => {
  const t = useTranslation();
  //const {isLogin} = store.user;
  return (
    <div className={cx(styles.nodata, className)}>
      <div>
        <XtSvg src={NoDataLightSvg} />
        <XtSvg src={NoDataSvg} />
        <p className={styles["nodata_font"]}>{nodata || t('account.noData')}</p>
      </div>
    </div>
  );
};
export default observer(NoData);
